import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export function MoreOrEqualThanDate(controlName: string, matchingControlName: string): ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup;
    const from = formGroup.controls[matchingControlName];
    const to = formGroup.controls[controlName];

    if (!from || !to || !from.value || !to.value) return null;
    if (to.value < from.value) {
      return { moreThan: true };
    }
    return null;
  };
}
